
function ErrorMessage({ err }) {
    return (
        <div className="error_cont">
            {err.display && <p className="error_message" id="err">{err.message}</p>}
        </div>
    );
}

export default ErrorMessage;